import { TimerOptions } from 'types';
import { timerMeasurementToString } from 'utils/embed/timer';
import { VideoTemplateStateContent } from '../../types';

export function getTimerOptions(
  state: VideoTemplateStateContent,
): TimerOptions<string> {
  const { timer } = state;
  return timerMeasurementToString(timer);
}
